import React, { useState, useEffect } from "react";

import moment from "moment-timezone";
import i18next from "i18next";

import { DataTypeDisplayValue } from "../DataTypeDisplayValue";
import { DeviceDataGraphModal } from "../Common";
import { FeatureAccess } from "../FeatureAccess";

import config from "config";
import { DeviceDataOverrideService } from "../../services";

const LastReceivedRow = ({ deviceId, deviceName, deviceType, device, dataType, thresholdsExceeded, deviceLastReceivedData, timezone }) => {
    const [showDeviceGraphModal, setShowDeviceGraphModal] = useState(false);
    const [dataTypeToken, setDataTypeToken] = useState(null);
    const [currentValue, setCurrentValue] = useState(null);
    const [currentValueTime, setCurrentValueTime] = useState(null);
    
    useEffect(() => {
        setDataTypeToken(dataType.token);
        if (thresholdsExceeded) {
            const foundThresholdExceeded = thresholdsExceeded.filter(thresholdExceeded => { 
                if (thresholdExceeded.deviceDataClassification) {
                    return thresholdExceeded.deviceDataClassification.id === dataType.deviceDataClassification?.id;
                } else {
                    return thresholdExceeded.deviceDataType.id === dataType.id;
                }
            });
            if (foundThresholdExceeded && foundThresholdExceeded.length > 0) {
                setDataTypeToken(foundThresholdExceeded[0].thresholdClassification.token);
            }
        }
    }, [dataType]);

    useEffect(() => {
        let value = deviceLastReceivedData.find((data) => data.deviceDataType.token === dataType.token);
        if (value?.numericValue != null) {
            value = { ...value, numericValue: DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(value.deviceDataType.token)(value.numericValue) };
        }
        setCurrentValue(value);
        setCurrentValueTime(value != null && value.deviceTime ? (timezone ? moment(value.deviceTime).tz(timezone) : moment(value.deviceTime)) : null);
    }, [deviceLastReceivedData, dataType]);

    return (
        <tr key={dataType.id}>
            <td>
                <img height="16" src={`${config.WEB_BASE_URL}/images/icon/sensor_${dataTypeToken}.svg`} /> {i18next.t(`device-data-types.${dataType.token}`)}
            </td>
            <td>
                <DataTypeDisplayValue value={currentValue} deviceTypeToken={deviceType.token} />
            </td>
            <td>{currentValueTime ? currentValueTime.fromNow() : i18next.t("unknown")}</td>
            <FeatureAccess feature="ENABLE_THRESHOLD_CLASSIFICATION_MATCHING">
                <td><ExclusionColumn deviceDataType={dataType} thresholdDeviceDataTypeExclusions={device.thresholdDeviceDataTypeExclusions} /></td>
            </FeatureAccess>
            <td>
                <a className="btn btn-sm btn-default" onClick={() => { setShowDeviceGraphModal(!showDeviceGraphModal); }} >
                    <img className="small-inline-icon" src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/charts.svg`} alt={i18next.t("data-chart")} />
                    {i18next.t("data-chart")}
                </a>
                <DeviceDataGraphModal 
                    entityTypeToken='device'
                    entityId={deviceId} 
                    entityName={deviceName} 
                    entity={device} 
                    dataType={dataType}
                    timezone={timezone}
                    show={showDeviceGraphModal}
                    onHide={() => { setShowDeviceGraphModal(!showDeviceGraphModal); }}
                />
            </td>
        </tr>
    );
};

const ExclusionColumn = ({deviceDataType, thresholdDeviceDataTypeExclusions}) => {
    if (thresholdDeviceDataTypeExclusions) {
        return thresholdDeviceDataTypeExclusions.find((exclusion) => exclusion.deviceDataType.id === deviceDataType.id) ? "Measurement Type Thresholds" : "None";
    } else {
        return "None";
    }
};

export default LastReceivedRow;